/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BrancheDto,
  ErrorResponse,
  OperationResponse,
  UpdatePrimesDeriveesBrancheCommand,
} from '../models/index';
import {
    BrancheDtoFromJSON,
    BrancheDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    UpdatePrimesDeriveesBrancheCommandFromJSON,
    UpdatePrimesDeriveesBrancheCommandToJSON,
} from '../models/index';

export interface UpdateBranchDerivedPremiumsRequest {
    brancheId: string;
    updatePrimesDeriveesBrancheCommand: UpdatePrimesDeriveesBrancheCommand;
}

/**
 * 
 */
export class BranchesApi extends runtime.BaseAPI {

    /**
     * Renvoie l\'intégralité des branches, sans restriction liée aux tunnels de l\'utilisateur. À ne pas confondre avec `risques/branches-courtier`, qui part des tunnels que le courtier connecté peut simuler : correct pour un parcours de souscription, mais incomplet pour un écran d\'administration, où l\'on doit pouvoir désigner une branche même sans y avoir le moindre tunnel.
     * Toutes les branches du référentiel
     */
    async getReferentialBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BrancheDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrancheDtoFromJSON));
    }

    /**
     * Renvoie l\'intégralité des branches, sans restriction liée aux tunnels de l\'utilisateur. À ne pas confondre avec `risques/branches-courtier`, qui part des tunnels que le courtier connecté peut simuler : correct pour un parcours de souscription, mais incomplet pour un écran d\'administration, où l\'on doit pouvoir désigner une branche même sans y avoir le moindre tunnel.
     * Toutes les branches du référentiel
     */
    async getReferentialBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BrancheDto>> {
        const response = await this.getReferentialBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Active ou désactive le calcul des primes dérivées (Cat Nat, Cat Tech, Attentat) de la branche et fixe leurs taux, en pourcentage de l\'assiette.
     * Régler les primes dérivées d\'une branche
     */
    async updateBranchDerivedPremiumsRaw(requestParameters: UpdateBranchDerivedPremiumsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['brancheId'] == null) {
            throw new runtime.RequiredError(
                'brancheId',
                'Required parameter "brancheId" was null or undefined when calling updateBranchDerivedPremiums().'
            );
        }

        if (requestParameters['updatePrimesDeriveesBrancheCommand'] == null) {
            throw new runtime.RequiredError(
                'updatePrimesDeriveesBrancheCommand',
                'Required parameter "updatePrimesDeriveesBrancheCommand" was null or undefined when calling updateBranchDerivedPremiums().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/branches/{brancheId}/primes-derivees`.replace(`{${"brancheId"}}`, encodeURIComponent(String(requestParameters['brancheId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePrimesDeriveesBrancheCommandToJSON(requestParameters['updatePrimesDeriveesBrancheCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Active ou désactive le calcul des primes dérivées (Cat Nat, Cat Tech, Attentat) de la branche et fixe leurs taux, en pourcentage de l\'assiette.
     * Régler les primes dérivées d\'une branche
     */
    async updateBranchDerivedPremiums(requestParameters: UpdateBranchDerivedPremiumsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBranchDerivedPremiumsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
